import {
    Chart,
    BarController,
    LineController,
    DoughnutController,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from 'chart.js'

// Registrazione esplicita dei soli componenti usati (tree-shaking di Chart.js).
Chart.register(
    BarController, LineController, DoughnutController,
    BarElement, LineElement, PointElement, ArcElement,
    CategoryScale, LinearScale, Tooltip, Legend
)

// Stessi colori del tema Vuetify definito in main.js.
export const COLORI = {
    primary: '#1F4FD1',
    primarySfumato: 'rgba(31, 79, 209, 0.75)',
    accent: '#6D3FD1',
    success: '#12875A',
    warning: '#C9790A',
    error: '#D3352E',
    secondary: '#44506B',
    grigio: '#B8BFCC',
}

export const PALETTE = [
    COLORI.primary, COLORI.accent, COLORI.success, COLORI.warning, COLORI.error, COLORI.secondary,
]
